export interface FundManagement {
  investmentProcess?: string
  firmAdvisor?: string
  advisor?: string
  is529: boolean
  ticker?: string
}

export interface AccordionData {
  heading?: string
  description?: string[]
  manager?: string
}

export class ManagementDetails {
  managementCompanies?: Corporation[]
}

export class Corporation {
  name?: string
  description?: string
  advisors?: Advisor[]
}

export class Advisor {
  name?: string
  credentials?: string
  description?: string
}
